import React from 'react';
import { Link } from 'react-router-dom';

import { colors, fonts, container, eyebrow, sectionHeading } from '../theme';
import { guides } from '../data';

export default function CityGuides() {
  return (
    <section id="guides" className="lyfe-wrap lyfe-sec" style={{ ...container, padding: '130px 40px 120px' }}>
      <div className="lyfe-reveal" style={{ maxWidth: 680, marginBottom: 64 }}>
        <div style={eyebrow(colors.blue)}>City guides</div>
        <h2 className="lyfe-h2" style={sectionHeading}>
          Miami, mapped by the
          <br />
          people who go out.
        </h2>
      </div>
      <div className="lyfe-g3" style={{ display: 'grid', gridTemplateColumns: 'repeat(3,1fr)', gap: 24 }}>
        {guides.map((g) => (
          <Link
            key={g.title}
            className="lyfe-card lyfe-reveal"
            to={g.href}
            style={{ display: 'block', textDecoration: 'none', color: 'inherit' }}>
            <div style={{ height: 360, borderRadius: 18, overflow: 'hidden', position: 'relative' }}>
              <img src={g.img} alt={g.title} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
              <div
                style={{
                  position: 'absolute',
                  inset: 0,
                  background: 'linear-gradient(to top,rgba(8,8,10,.92),rgba(8,8,10,.1) 60%)',
                }}
              />
              <div style={{ position: 'absolute', left: 24, right: 24, bottom: 24 }}>
                <div
                  style={{
                    fontSize: 12,
                    letterSpacing: '.16em',
                    textTransform: 'uppercase',
                    color: colors.muted2,
                    marginBottom: 8,
                  }}>
                  {g.spots}
                </div>
                <h3 style={{ fontFamily: fonts.serif, fontWeight: 400, fontSize: 30 }}>{g.title}</h3>
                <p style={{ fontSize: 14, lineHeight: 1.5, color: colors.muted, marginTop: 8 }}>{g.body}</p>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}
